import React from 'react';

const PolitiqueConfidentialite = () => {
  return (
    <main className="min-h-screen">
      <div className="pt-20">
        <section className="section bg-white">
          <div className="container mx-auto max-w-4xl">
            <h1 className="heading-xl mb-8 text-gray-900">Politique de confidentialité</h1>
            
            <div className="prose prose-lg max-w-none">
              <h2 className="heading-lg mt-8 mb-4">Collecte des données</h2>
              <p className="text-body text-gray-700 mb-4">
                Nous collectons uniquement les données nécessaires au bon fonctionnement de notre service et à la gestion de votre relation client.
              </p>

              <h2 className="heading-lg mt-8 mb-4">Utilisation des données</h2>
              <p className="text-body text-gray-700 mb-4">
                Vos données personnelles sont utilisées uniquement dans le cadre de nos services et ne sont jamais transmises à des tiers sans votre consentement.
              </p>

              <h2 className="heading-lg mt-8 mb-4">Vos droits</h2>
              <p className="text-body text-gray-700 mb-4">
                Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression de vos données personnelles.
              </p>

              <h2 className="heading-lg mt-8 mb-4">Contact</h2>
              <p className="text-body text-gray-700 mb-4">
                Pour toute question concernant vos données personnelles, contactez-nous au +33 9 78 80 26 23
              </p>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
};

export default PolitiqueConfidentialite;